<script lang="ts">
	//Hooks
	import { createEventDispatcher } from 'svelte';
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import {
		ActionsContainer,
		AdvancedCard,
		Alert,
		IconButton,
		LabelList,
		Text,
	} from '@Shelly/shelly-design-system';
	//Helpers
	import { isWallDisplay, real_id } from 'src/helpers/interface_helpers';
	import { navigateToSetting } from 'src/stores/ui/navigate-to';
	import { stringifyLocalAction } from 'src/helpers/actions/local/ui/local_actions_view_helpers';

	export let foundDevices = [];
	export let devicesWithSameIP: string[] = [];

	let dispatchEvent = createEventDispatcher();
</script>

{#if foundDevices.length}
	{#if devicesWithSameIP.length > 1}
		<Alert
			class="mb-s"
			type="warning"
			heading={$format('webhooks_device_duplicate_ip', {
				default: 'This device shares the same IP with another.',
			})}
		/>
	{/if}
	{#each foundDevices as deviceInfo}
		{@const localAction = stringifyLocalAction(deviceInfo.action, deviceInfo.device)}
		<div class="d-flex align-items-center justify-content-between">
			<Text class="text-bold mr-s" styleType="body-small" noWrap>
				{@html localAction}
			</Text>
			<slot name="delete-btn" />
		</div>

		<hr class="mt-s mb-s" />

		{#if deviceInfo.action?.error}
			<Alert
				class="mb-s"
				type="warning"
				heading={$format('text_actions_invalid_command', {
					default: 'Invalid webhook command.',
				})}
			/>
		{:else if deviceInfo.isNotOnTheSameNetwork}
			<Alert
				class="mb-s"
				type="warning"
				heading={$format('webhooks_device_is_not_on_the_same_network', {
					default: 'The device is not on the same Wi-Fi network.',
				})}
			/>
		{:else if !deviceInfo.hasStaticIP}
			{#if isWallDisplay(deviceInfo.device.type)}
				<Alert
					class="mb-s"
					type="info"
					heading={$format('webhooks_suggest_static_ip_address', {
						default: 'We suggest assigning it a static IP address.',
					})}
					message={$format('webhooks_set_static_ip_address_walldispay', {
						default:
							"Make sure that the device's IP address is reserved in the address reservation table of the Wi-Fi router.",
					})}
				/>
			{:else}
				<Alert
					class="mb-s"
					type="info"
					heading={$format('webhooks_suggest_static_ip_address', {
						default: 'We suggest assigning it a static IP address.',
					})}
					cta={{
						title: $format('webhooks_set_static_ip_address', {
							default: 'Set static IP address.',
						}),
					}}
					on:cta_click={() =>
						navigateToSetting(real_id(deviceInfo.id), 'networks', 'wifi_mode_client')}
				/>
			{/if}
		{/if}

		<AdvancedCard size="m" {...deviceInfo} class="mb-s">
			<LabelList
				size="m"
				labelList={deviceInfo.labelList}
				slot="main"
				data-prevent-drawer-swipe
				data-prevent-sidepanel-swipe
			/>
			<ActionsContainer orientation="horizontal" type="simple" slot="right">
				<IconButton
					aria-label={$format('button_edit_webhook', {
						default: 'Button edit webhook',
					})}
					icon="fas fa-pen"
					slot="first"
					on:click={() => {
						dispatchEvent('edit', deviceInfo);
					}}
				/>
			</ActionsContainer>
		</AdvancedCard>
	{/each}
{/if}
